import React from 'react';

import { Emoji, EmojiCode } from '@/components/shared/Emoji';
import { classNames } from '@/helpers/classNames';
import constants from '@/theme/exportedVariables.module.scss';
import { useMediaQuery } from '@material-ui/core';

import styles from './MessageReaction.module.scss';

export interface MessageReactionProps {
	values: string[];
	onClick: () => void;
	className?: string;
}

export const MessageReaction = ({
	values,
	onClick,
	className,
}: MessageReactionProps) => {
	const isTablet = useMediaQuery(`(min-width: ${constants.sizeTablet}`);

	const emojis = distinct(values);
	return (
		<div
			className={classNames([
				styles['reaction'],
				isTablet && styles['hover'],
				className,
			])}
			onClick={onClick}
		>
			{emojis.map((code, idx) => (
				<Emoji key={`reaction-${idx}`} code={code} />
			))}
			<span className={styles['reaction__number']}>{values.length}</span>
		</div>
	);
};

function distinct(codes: string[]) {
	const emojiTypes = codes.reduce((aggr, code) => {
		aggr[code] = code;

		return aggr;
	}, {} as { [key in string]: string });

	return Object.values(emojiTypes);
}
